import { useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "@/components/ui/button";
import Active from "./Active";
import { Line } from "@/components/CustomUI/modules/Loaders";
import { getCartDataApi, removeCouponCodeApi, applyCouponCodeApi } from "@/clientSideApi/cart";
import { setCartData } from "@/store/cart/cartSlice";

const Voucher = () => {
  const dispatch = useDispatch();
  const { voucher, total_mrp, total_price } = useSelector(
    (state) => state.cart.data.cart
  );

  const [loading, setLoading] = useState(false);
  const [ error, setError ] = useState(null);
  const [voucherInput, setVoucherInput] = useState("");

  const handleVoucherChange = (e) => {
    setVoucherInput(e.target.value);
  };

  const handleCouponSubmit = useCallback(async () => {
    if (!voucherInput || loading) return;
    setError(null);
    setLoading(true);
    const apiResponse = await applyCouponCodeApi(voucherInput);
    if(apiResponse.error){
        setError(apiResponse.error);
        setLoading(false);
        return;
    }
    const cartApiResponse = await getCartDataApi();
    if (!cartApiResponse) return setLoading(false);
    dispatch(setCartData(cartApiResponse));
    setLoading(false);
  }, [ voucherInput, loading, dispatch ]);

  const removeCurrentCoupon = useCallback(async () => {
    setLoading(true);
    const couponRemoved = await removeCouponCodeApi();
    if (!couponRemoved) return setLoading(false);
    const cartApiResponse = await getCartDataApi();
    if (!cartApiResponse) return setLoading(false);
    dispatch(setCartData(cartApiResponse));
    setLoading(false);
  }, [ dispatch ]);

  const onFocus = () => setError(false);


  const handleKeyDown = (e) => {
    if (e.keyCode === 13) handleCouponSubmit();
  };

  return (
    <div>
      {voucher ? (
        <Active
          voucher={voucher}
          loading={loading}
          totalDiscountValue={total_mrp - total_price}
          removeCurrentCoupon={removeCurrentCoupon}
        />
      ) : (
        <>
            <div className="h-[45px] flex ">
            <input
                className={`
                        p-2 border text-font-primaryMuted h-full w-full 
                        hover:outline-none focus:outline-none
                        placeholder:text-slate-400 border-r-0 rounded-l-sm
                        placeholder:text-sm placeholder:tracking-wide 
                        ${error ? "border-[red]" : "border-slate-300"}
                    `}
                placeholder="Voucher or Referral Code"
                type="text"
                value={voucherInput}
                onChange={handleVoucherChange}
                onFocus={onFocus}
                onKeyDown={handleKeyDown}
            />
            <Button
                variant="outline"
                className="
                    h-full w-auto min-w-[80px] select-none bg-[#45D4D5]
                    hover:drop-shadow rounded-r-sm rounded-l-none 
                    hover:bg-[#56f0f1] border border-slate-300 border-l-0
                    text-font-primary text-[12px] md:text-sm font-semibold
                "
                onClick={handleCouponSubmit}
            >
                {loading ? <Line loading={true} /> : <span>Apply</span>}                
            </Button>
            </div>
            <div className="flex items-center text-xs text-[red] h-[22px] line-clamp-1 text-ellipsis overflow-hidden">
                {error}
            </div>
        </>
      )}
    </div>
  );
};

export default Voucher;
